import React from 'react';
import {Link} from 'react-router-dom';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-brand-navy pb-8 pt-16">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 flex flex-col items-center justify-between gap-8 border-b border-white/10 pb-12 md:flex-row md:items-start">
          <div className="text-center md:text-left">
            <Link to="/"><Logo className="mb-4 justify-center md:justify-start" variant="dark" /></Link>
            <p className="mt-4 max-w-xs text-white/70">Empowering Goulburn with safe, confident automatic driving skills.</p>
          </div>
          <div className="flex flex-col gap-12 text-center sm:flex-row md:text-left">
            <div>
              <h4 className="mb-4 font-display text-lg text-white">Quick Links</h4>
              <ul className="space-y-2 text-white/70">
                <li><Link to="/#home" className="transition-colors hover:text-brand-gold">Home</Link></li>
                <li><Link to="/#instructors" className="transition-colors hover:text-brand-gold">Instructors</Link></li>
                <li><Link to="/guides" className="transition-colors hover:text-brand-gold">Guides &amp; Resources</Link></li>
                <li><Link to="/review" className="transition-colors hover:text-brand-gold">Leave a Review</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="mb-4 font-display text-lg text-white">Contact Drive Pal</h4>
              <ul className="space-y-2 text-white/70">
                <li>Goulburn, NSW</li>
                <li><a href="tel:0426501299" className="transition-colors hover:text-brand-gold">Santosh: 0426 501 299</a></li>
                <li><a href="mailto:book.drivepal@gmail.com" className="break-words transition-colors hover:text-brand-gold">book.drivepal@gmail.com</a></li>
              </ul>
            </div>
            <div>
              <h4 className="mb-4 font-display text-lg text-white">Legal</h4>
              <ul className="space-y-2 text-white/70">
                <li><Link to="/compliance" className="transition-colors hover:text-brand-gold">Compliance &amp; Policies</Link></li>
                <li><a href="https://drivepal-lessonplanner.base44.app/" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-brand-gold">Lesson Planner</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mx-auto mb-8 max-w-4xl rounded-xl border border-brand-gold/50 bg-brand-gold/15 px-5 py-4 text-center shadow-inner">
          <p className="font-semibold text-brand-gold">To report misconduct by a driving instructor, call Transport for NSW on{' '}
            <a href="tel:131500" className="underline underline-offset-4 transition-colors hover:text-white">131 500</a>.
          </p>
        </div>
        <div className="space-y-4 text-center text-xs text-white/50 md:text-sm">
          <p className="mx-auto max-w-4xl rounded-xl border border-white/10 bg-white/5 p-4 italic">Drive Pal is an independent driving school and is not affiliated with or endorsed by Service NSW or Transport for NSW. Mock assessments are preparation sessions only and are not official NSW driving tests. Actual test routes and test outcomes are determined solely by Transport for NSW.</p>
          <div className="space-y-2">
            <p className="font-medium">ABN: 277 826 510 53</p>
            <p>&copy; 2026 Drive Pal Driving School. All rights reserved.</p>
            <p className="italic text-white/30">Proudly serving Goulburn, NSW.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}